export default function NewZealandInfo() {
    return (
        <>
            {/* Main Colored Section */}
            <section className="w-full bg-[#C67B3E] py-12 px-4 sm:px-6 lg:px-16">
                <div className="max-w-7xl mx-auto text-center lg:text-left">
                    <h3 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white mb-6">
                        Best New Zealand Student Visa Consultant in Ahmedabad
                    </h3>

                    <p className="text-justify text-base sm:text-lg lg:text-xxl text-white/90 leading-relaxed max-w-8xl mx-auto lg:mx-0">
                        New Zealand is globally recognized as one of the safest and most preferred destinations 
                        for international students pursuing higher education abroad. With its world-class 
                        education system, strong academic standards, and exceptional quality of life, 
                        the country attracts thousands of students from across the globe every year.
                    </p>

                    <br />

                    <p className="text-justify text-base sm:text-lg lg:text-xxl text-white/90 leading-relaxed max-w-8xl mx-auto lg:mx-0">
                        From science, arts, and humanities to business, technology, and design, 
                        New Zealand offers a wide range of career-focused programs tailored to 
                        diverse academic backgrounds and professional aspirations. Students from India 
                        especially prefer New Zealand due to its high-quality education, practical learning approach, 
                        and promising post-study work opportunities.
                    </p>

                    <br />

                    <p className="text-justify text-base sm:text-lg lg:text-xxl text-white/90 leading-relaxed max-w-8xl mx-auto lg:mx-0">
                        Choosing the right course based on your eligibility and long-term career goals 
                        is crucial. A trusted New Zealand Student Visa Consultant in Ahmedabad can guide 
                        you through course selection, university applications, documentation, and the 
                        complete student visa process — ensuring accuracy and minimizing the risk of rejection.
                    </p>

                    <br />

                    <p className="text-justify text-base sm:text-lg lg:text-xxl text-white/90 leading-relaxed max-w-8xl mx-auto lg:mx-0">
                        If you are planning to study abroad for better career prospects, seeking 
                        professional guidance from an experienced and reputable consultant is 
                        the most reliable way to confidently begin your journey to study in New Zealand.
                    </p>
                </div>
            </section>
        </>
    );
}